module.exports = __webpack_public_path__ + "img/activities.f4a5a9cb.png";